import React from "react";
import { BandingList } from "./BandingList.Logic";
import { ListOfBands } from "./Constant";
import { CreateBanding } from "./CreateBanding.Logic";
import { OutputBandingPopup } from "./OutputBandingPopup/OutputBandingPopup.logic";
import { BandsTypes } from "./Types";

/**
 * Responsible for rendering landing page of banding
 * @returns Banding Landing Page
 */
export const BandingLandingPageView: React.FC = () => {
  return (
    <>
      <CreateBanding />
      <div
        className="ebt-output-config__banding-container"
        id="ebt-outputConfig-banding-list"
      >
        {ListOfBands?.map((band: BandsTypes, index: number) => {
          return <BandingList key={index + 1} bandType={band} />;
        })}
      </div>
      <div>
        <OutputBandingPopup />
      </div>
    </>
  );
};
